import { getMapLayerFilter } from "./getMapLayerFilter";

export default getMapLayerFilter;
